// 連携できる外部サービスのカタログ（フロント表示用）。
// provider 値（id）はバックエンドの providers._PROVIDERS のキーと一致させること。
// tokenPageUrl は非秘密なので公開 env（.env.development / .env.production）で管理する。

export type ServiceCatalogEntry = {
  id: string
  label: string
  description: string
  tokenPageUrl: string
}

export const SERVICE_CATALOG: ServiceCatalogEntry[] = [
  {
    id: 'shift_senshi',
    label: 'shiftRG',
    description: 'バイトのシフト履歴から節目を実績として取り込む',
    tokenPageUrl: import.meta.env.VITE_SHIFTRG_TOKEN_PAGE_URL ?? '',
  },
  {
    id: 'skt-sebas',
    label: '就活セバス',
    description: '就活の選考イベントや活動量を実績として取り込む',
    tokenPageUrl: import.meta.env.VITE_SEBAS_TOKEN_PAGE_URL ?? '',
  },
]
